import React, { useEffect, useState } from 'react';
import PaymentIcon from '@mui/icons-material/Payment';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import visa from '../../../assets/visa.png';
import DeleteIcon from '@mui/icons-material/Delete';
import { HiMiniTrash } from "react-icons/hi2";
import { BsTrash3Fill } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import { environment } from 'apps/table-tuck-web/src/environments/environment';
import { useSelector } from 'react-redux';
import { firestore } from '@tabletuck/firebase-services';
import { useTheme } from '@emotion/react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from 'axios';
import { async } from 'regenerator-runtime';
import { auth } from '../../../../../../libs/firebase-service/src';
import amex from '../../../assets/amex.png';
import discover from '../../../assets/dicover.png';
import dinars from '../../../assets/dinars.png';
import geniric from '../../../assets/geniric.png';
import jbc from '../../../assets/geniric.png';
import mastercard from '../../../assets/mastercard.png';
import unionpay from '../../../assets/unionpay.png';
import { useTranslation } from 'react-i18next';
import PaymentHandler from '../../Pages/PaymentHandler/PaymentHandler';

const Payment = () => {
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  const nav = useNavigate();
  const token = useSelector((state) => state.authReducer.token);
  const [open, setOpen] = useState(false);
  const [showAddPaymentForm,setShowAddPaymentForm] = useState(false);
  const [selectCardToDelete, setSelectCardToDelete] = useState('');
  const [t, i18n] = useTranslation();

  function handleCancel() {
    setShowAddPaymentForm(false);
  }
  const handleDelete = async (cc) => {
    try {
      auth?.currentUser.getIdToken().then(async (token) => {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: token,
        };
        await axios.post(
          `${environment?.apiUrl}/deleteCard?restaurantId=${environment.restaurantId}`,
          {
            token: selectCardToDelete?.id,
          },
          { headers }
        );
      });
    } catch (err) {
      console.log(err, 'err');
    }
    setOpen(false);
  };

  

  const handleClose = () => {
    setOpen(false);
  };


  const handleCancelAddPayment = () => {
    if (formChanged) {
      setShowCancelDialog(true); 
    } else {
      setShowAddPaymentForm(false); 
    }
  };

  const handleClickOpen = () => {
    
    setShowAddPaymentForm(true); 


  };

  const [methods, setMethods] = useState(['']);
  const [loading, setLoading] = useState('');
  let getData = async () => {
    try {
      const querySnapshot = await firestore
        .collection(
          `users/${auth?.currentUser?.uid}/private_data/cards/sources`
        )
        .get();

      const arr = [];
      querySnapshot.forEach((doc) => {
        arr.push(doc.data());
      });
      setMethods(arr);
    } catch (e) {
      console.log('Error in payment:', e.message);
    }
  };
  useEffect(() => {
    getData();
  }, [methods]);
  // useEffect(() => {
  //   const unsubscribe = firestore
  //     .collection(`users/${auth?.currentUser?.uid}/private_data/cards/sources`)
  //     .onSnapshot((querySnapshot) => {
  //       const arr = [];
  //       querySnapshot.forEach((doc) => {
  //         arr.push(doc.data());
  //       });
  //       setMethods(arr);
  //       setLoading(false);
  //     });
  //   return () => unsubscribe();

  // }, [])

  return (<>
    {showAddPaymentForm ? (<Box sx={{
          backgroundColor: '#151414',
borderRadius: '15px',
padding: '20px',
boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
marginTop: { xs: '10px',sm:'150px', md: '20px' },
marginLeft: { xs: '10px', sm: '40px' ,md:'50px' },
marginRight: { xs: '10px', md: '50px' },
marginBottom :{xs:"170px" ,md :"170px" ,lg:"170px",},
maxWidth: '900px',
minHeight: '510px',
          
        }}>
      <PaymentHandler onCancel={handleCancel}/>
      </Box>):( <div
      className="mt-3.5"
      dir={i18n.language === 'ar' || i18n.language === 'he' ? 'rtl' : 'ltr'}
    >
      <Box
      sx={{
        backgroundColor: '#151414',
        borderRadius: '15px',
        padding: '20px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        marginTop: { xs: '10px',sm:'150px', md: '20px' },
        marginLeft: { xs: '10px', md: '50px' },
        marginRight: { xs: '10px', md: '0px' },
        maxWidth: '900px',
        minHeight: '510px',
        
      }}>
        <Box sx={{ display:"flex",
        justifyContent:"space-between"}}>
         <Typography
        style={{
          fontFamily:"OutFit",
          fontWeight: 'bold',
          color: '#FFFFFF',
          fontSize: '20px',
          marginBottom: '60px',
        }}
      >
        {t('paymentMethods')}
      </Typography>
      <div>
        <button
          disableRipple={true}
          disableFocusRipple={true}
          disableTouchRipple={true}
          onClick={handleClickOpen}
          variant="text"
          style={{
            width: '100%',
            boxShadow:
              '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
            color: "#fff",
            fontFamily:"OutFit",
            backgroundColor:environment.mainColor,
            padding: '10px',
            borderRadius: '20px',
            fontWeight: 'bold',
          }}
        >
          {' '}
         {t('profilee.addAPaymentMethod')}
        </button>
      </div>
      </Box>
      {methods.map((item) => (
        <div>
          <div
            class="flex flex-col md:flex-row  rounded-lg  shadow-lg"
            style={{
              marginTop: '25px',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              justifyContent: 'space-between',
              padding: '5px',
              backgroundColor:"#262626",
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={
                  item?.brand === 'American Express'
                    ? amex
                    : item?.brand === 'Diners Club'
                    ? dinars
                    : item?.brand === 'Discover'
                    ? discover
                    : item?.brand === 'JCB'
                    ? jbc
                    : item?.brand === 'Visa'
                    ? visa
                    : item?.brand === 'MasterCard'
                    ? mastercard
                    : item?.brand === 'UnionPay'
                    ? unionpay
                    : geniric
                }
                alt="visa"
                style={{
                  color: 'white',
                  width: '60px',
                  height: '50px',
                  borderRadius: '5px',
                  marginRight: 5,
                }}
              />
              <h5
                class="text-gray-100 text-lg font-small "
                style={{ color: '#fff' }}
              >
                ****{item.last4}
              </h5>
            </div>
            <BsTrash3Fill
              style={{ color: "#FF0B00" ,marginRight:"20px" ,fontSize:"20px"}}
              onClick={() => {
                setOpen(true);
                setSelectCardToDelete(item);
              }}
            />
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title"></DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {t('profilee.deleteCreditCard')}
                </DialogContentText>
              </DialogContent>
              <DialogActions dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                <Button
                  style={{ color: environment?.mainColor }}
                  onClick={() => handleDelete(item)}
                >
                  {t('profilee.yes')}
                </Button>
                <Button
                  style={{ color: environment?.mainColor }}
                  onClick={handleClose}
                  autoFocus
                >
                  {t('profilee.cancel')}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      ))}
      </Box>
      
    </div>)}
    </>
  );
};
export default Payment;
